import { FC } from 'react'
import { Box, ButtonBase, Typography } from '@mui/material'
import {
  BLUE_DARK_COLORS_VARIANTS,
  GRAY_COLORS_VARIANTS,
  LIVE_INDICATOR_COLOR,
  TEXT_DARK_COLORS_VARIANTS,
} from '@/utils/constants/colors'

export interface StatusFilterProps {
  activeId: number | null
  statusId: number
  statusLabel: string
  isLive?: boolean
  onClick: (statusId: number) => void
}

export const FilterStatusElement: FC<StatusFilterProps> = ({
  activeId,
  statusId,
  statusLabel,
  isLive,
  onClick,
}) => {
  const isActive = activeId !== null && activeId === statusId

  return (
    <ButtonBase
      onClick={() => onClick(statusId)}
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '0.375rem',
        borderRadius: '2rem',
        px: '1rem',
        py: '0.5rem',
        backgroundColor: isActive ? GRAY_COLORS_VARIANTS[50] : 'transparent',
        color: isActive ? TEXT_DARK_COLORS_VARIANTS[500] : GRAY_COLORS_VARIANTS[100],
        transition: 'all 0.2s ease',
        '&:hover': {
          backgroundColor: isActive
            ? BLUE_DARK_COLORS_VARIANTS[100]
            : BLUE_DARK_COLORS_VARIANTS[200],
        },
      }}
    >
      {isLive && (
        <Box
          sx={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            backgroundColor: LIVE_INDICATOR_COLOR,
            '@keyframes pulse': {
              '0%': { opacity: 1 },
              '50%': { opacity: 0.5 },
              '100%': { opacity: 1 },
            },
            animation: 'pulse 1.2s ease-in-out infinite',
            flexShrink: 0,
          }}
        />
      )}
      <Typography
        sx={{
          fontSize: '0.875rem',
          fontWeight: isActive ? 600 : 400,
          lineHeight: 1,
          whiteSpace: 'nowrap',
          color: 'inherit',
        }}
      >
        {statusLabel}
      </Typography>
    </ButtonBase>
  )
}
